import styled from 'styled-components';

import { Text } from '@dreryk/react-components';

export const StyledPriceText = styled(Text)`
   color: ${(props) => props.theme.textBody};
`;
StyledPriceText.displayName = 'StyledPriceText';
